import { useEffect, useRef, useState } from 'react'
import { Props_SnippetParallaxImage } from './ParallaxImage.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetParallaxImage = (props: Props_SnippetParallaxImage) => {
    const { image, heading, content, link } = props;

    const sectionRef = useRef<HTMLElement | null>(null);
    const [parallaxOffset, setParallaxOffset] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (sectionRef.current) {
                const rect = sectionRef.current.getBoundingClientRect();
                const top = rect.top;

                const offset = top * -0.5;
                setParallaxOffset(offset);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
        

    return (
        <section className="snippet-parallax-image" ref={sectionRef}>
            <div
                className="snippet-parallax-image__background"
                style={{
                    backgroundImage: `url(${image.src.value})`,
                    transform: `translateY(${parallaxOffset}px)`
                }}
            />
            <div className="snippet-parallax-image__content">
                <div className="snippet-parallax-image__content-inner">
                    <h2 className="snippet-parallax-image__heading">{heading.content?.value}</h2>
                    <div className="snippet-parallax-image__text">
                        { Legacy_CompileMarkdown(content.content?.value || '') }
                    </div>
                    <SnippetLink 
                        linkStyles={link.linkStyle?.value} 
                        className="snippet-image-content__link" 
                        url={link.linkHref?.value} 
                        openInNewTab={link.linkTarget?.value}
                    >
                        {link.linkText?.value}
                    </SnippetLink>
                </div>
            </div>
        </section>
    )
}

export default SnippetParallaxImage;